import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBilingual } from '../hooks/useBilingual';
import axios from 'axios';
import './HomePage.css';

const HomePage = () => {
  const { t } = useTranslation();
  const { tb } = useBilingual();
  // 로그인 상태 확인
  const isLoggedIn = !!localStorage.getItem('token');
  const userType = localStorage.getItem('userType');
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  const [bookList, setBookList] = useState([]);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/books/?limit=100`);
        setBookList(res.data || []);
      } catch (e) {
        // ignore silently for homepage showcase
        setBookList([]);
      }
    };
    fetchBooks();
  }, [API_BASE_URL]);

  const getTestLink = (title, author, id) => {
    // const normalize = (s) => (s || '').toString().trim().toLowerCase();
    // const matched = bookList.find(
    //   (b) => normalize(b.title) === normalize(title) && (!author || normalize(b.author) === normalize(author))
    // );
    // return matched ? `/test?bookId=${matched.id}` : '/test';
    return `/test?bookId=${id}`;
  };
  return (
    <div className="home-page">
      <div className="container">
        {/* Hero Section */}
        <section className="hero fade-in">
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="title">
                <span className="title-brand">LIDIA</span>
                <span className="title-desc">
                  {' : '}
                  <span className="title-accent">L</span>
                  <span className="title-accent">I</span>
                  {'teracy + I'}
                  <span className="title-accent">D</span>
                  {'ea + '}
                  <span className="title-accent">I</span>
                  {'ntelligence + '}
                  <span className="title-accent">A</span>
                  {'I'}
                </span>
              </span>
              <span className="highlight">{tb('home.subtitle')}</span>
            </h1>
            <div className="welcome-message">
              <div className="hero-buttons">
                <Link to="/test" className="btn btn-primary btn-large play-btn">
                  {tb('common.play')}
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Available Books Section */}
        <section className="available-books">
          <div className="books-showcase">
                <Link to={getTestLink('어린왕자', '생텍쥐페리', 1)} className="book-item">
              <div className="book-cover little-prince">
                <div className="language-badge">Ko</div>
                <div className="book-info">
                  <div className="book-title">어린왕자</div>
                  <div className="book-subtitle">생텍쥐페리</div>
                </div>
              </div>
            </Link>
                <Link to={getTestLink('노인과 바다', '헤밍웨이', 2)} className="book-item">
              <div className="book-cover old-man-sea">
                <div className="language-badge">Ko</div>
                <div className="book-info">
                  <div className="book-title">노인과 바다</div>
                  <div className="book-subtitle">헤밍웨이</div>
                </div>
              </div>
            </Link>
                <Link to={getTestLink('Frankenstein', 'Mary Shelley', 3)} className="book-item">
              <div className="book-cover frankenstein">
                <div className="language-badge">En</div>
                <div className="book-info">
                  <div className="book-title">Frankenstein</div>
                  <div className="book-subtitle">Mary Shelley</div>
                </div>
              </div>
            </Link>
                <Link to={getTestLink('The Great Gatsby', 'F. Scott Fitzgerald', 5)} className="book-item">
              <div className="book-cover great-gatsby">
                <div className="language-badge">En</div>
                <div className="book-info">
                  <div className="book-title">The Great Gatsby</div>
                  <div className="book-subtitle">F. Scott Fitzgerald</div>
                </div>
              </div>
            </Link>
                <Link to={getTestLink('Peter Pan', 'J. M. Barrie', 6)} className="book-item">
              <div className="book-cover peter-pan">
                <div className="language-badge">En</div>
                <div className="book-info">
                  <div className="book-title">Peter Pan</div>
                  <div className="book-subtitle">J. M. Barrie</div>
                </div>
              </div>
            </Link>
            <Link to={getTestLink('The Little Prince', 'Antoine de Saint-Exupéry', 7)} className="book-item">
              <div className="book-cover little-prince">
                <div className="language-badge">En</div>
                <div className="book-info">
                  <div className="book-title">The Little Prince</div>
                  <div className="book-subtitle">Antoine de Saint-Exupéry</div>
                </div>
              </div>
            </Link>
            <Link to={getTestLink('Alice in Wonderland', 'Lewis Carroll', 8)} className="book-item">
              <div className="book-cover alice-in-wonderland">
                <div className="language-badge">En</div>
                <div className="book-info">
                  <div className="book-title">Alice in Wonderland</div>
                  <div className="book-subtitle">Lewis Carroll</div>
                </div>
              </div>
            </Link>
            <Link to={getTestLink('Around the World in Eighty Days', 'Jules Verne', 9)} className="book-item">
              <div className="book-cover around-the-world">
                <div className="language-badge">En</div>
                <div className="book-info">
                  <div className="book-title">Around the World in Eighty Days</div>
                  <div className="book-subtitle">Jules Verne</div>
                </div>
              </div>
            </Link>
            <Link to={getTestLink('The Jungle Book', 'Rudyard Kipling', 10)} className="book-item">
              <div className="book-cover jungle-book">
                <div className="language-badge">En</div>
                <div className="book-info">
                  <div className="book-title">The Jungle Book</div>
                  <div className="book-subtitle">Rudyard Kipling</div>
                </div>
              </div>
            </Link>
            <Link to={getTestLink('THE SORROWS OF YOUNG WERTHER', 'J.W. von Goethe', 11)} className="book-item">
              <div className="book-cover young-werther">
                <div className="language-badge">En</div>
                <div className="book-info">
                  <div className="book-title">THE SORROWS OF YOUNG WERTHER</div>
                  <div className="book-subtitle">J.W. von Goethe</div>
                </div>
              </div>
            </Link>
            <Link to={getTestLink('The Invisible Man', 'H. G. Wells', 12)} className="book-item">
              <div className="book-cover invisible-man">
                <div className="language-badge">En</div>
                <div className="book-info">
                  <div className="book-title">The Invisible Man</div>
                  <div className="book-subtitle">H. G. Wells</div>
                </div>
              </div>
            </Link>
            <Link to={getTestLink('THE ALCHEMIST', 'Ben Jonson', 13)} className="book-item">
              <div className="book-cover alchemist">
                <div className="language-badge">En</div>
                <div className="book-info">
                <div className="book-title">THE ALCHEMIST</div>
                <div className="book-subtitle">Ben Jonson</div>
                </div>
              </div>
            </Link>
            <div className="book-item more-coming">
              <div className="book-cover">
                <div className="book-info">
                  <div className="more-coming-text">More Books<br/>Coming Soon</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features">
          <h2 className="section-title">{tb('home.mainFeatures')}</h2>
          <div className="features-container">
            <div className="feature-card-unified fade-in">
              <div className="feature-item">
                <h3>{tb('home.interactiveGame')}</h3>
                <p>{tb('home.interactiveGameDescription')}</p>
              </div>
              <div className="feature-item">
                <h3>{tb('home.personalityAnalysis')}</h3>
                <p>{tb('home.personalityAnalysisDescription')}</p>
              </div>
              <div className="feature-item">
                <h3>{tb('home.personalizedExperience')}</h3>
                <p>{tb('home.personalizedDescription')}</p>
              </div>
              <div className="feature-item">
                <h3>{tb('home.literacyCertification')}</h3>
                <p>{tb('home.literacyCertificationDescription')}</p>
              </div>
            </div>
          </div>
        </section>

        {/* How it works */}
        <section className="how-it-works">
          <h2 className="section-title">{tb('home.howItWorks')}</h2>
          <p>{tb('home.howItWorksDescription')}</p>
          <div className="steps">
            <div className="step fade-in">
              <div className="step-number">1</div>
              <h3>{tb('home.step1Title')}</h3>
              <p className="step-description">{tb('home.step1Description')}</p>
            </div>
            
            <div className="step fade-in">
              <div className="step-number">2</div>
              <h3>{tb('home.step2Title')}</h3>
              <p className="step-description">{tb('home.step2Description')}</p>
            </div>
          
            <div className="step fade-in">
              <div className="step-number">3</div>
              <h3>{tb('home.step3Title')}</h3>
              <p className="step-description">{tb('home.step3Description')}</p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta fade-in">
          <div className="cta-content">
            <h1 className="cta-main-title">{tb('home.ctaMainTitle')}</h1>
            <h2 className="cta-subtitle" dangerouslySetInnerHTML={{ __html: tb('home.ctaSubtitle').replace('\n', '<br/>') }}></h2>
            <p className="cta-description-en" dangerouslySetInnerHTML={{ __html: tb('home.ctaDescriptionEn').replace('\n', '<br/>') }}></p>
            <p className="cta-description-ko" dangerouslySetInnerHTML={{ __html: tb('home.ctaDescriptionKo').replace('\n', '<br/>') }}></p>
            {isLoggedIn ? (
              userType === 'student' ? (
                <div className="cta-buttons">
                  <Link to="/test" className="btn btn-quest btn-large">
                    {tb('home.startTheQuest')}
                  </Link>
                </div>
              ) : (
                <div className="cta-buttons">
                  <Link to="/admin" className="btn btn-quest btn-large">
                    {tb('home.startTheQuest')}
                  </Link>
                </div>
              )
            ) : (
              <div className="cta-buttons">
                <Link to="/register" className="btn btn-quest btn-large">
                  {tb('home.startTheQuest')}
                </Link>
                <Link to="/test" className="btn btn-trial btn-large">
                  {tb('home.tryWithoutLogin')}
                </Link>
              </div>
            )}
          </div>
        </section>

        {/* NEXMAP Section */}
        <section className="nexpa-map fade-in">
          <div className="nexpa-map-content">
            <h2 className="nexpa-map-title">NEXPA MAP</h2>
            <div className="nexpa-map-images">
              <div className="map-image-container">
                <img src="/nexpa-map2.png" alt="NEXMAP 2" className="nexpa-map-image" />
              </div>
              <div className="map-image-container">
                <img src="/nexpa-map3.png" alt="NEXMAP 3" className="nexpa-map-image" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePage; 